var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"btn-box"},[_c('div',{staticClass:"download",on:{"click":_vm.download}},[_vm._v("下载客户端")])])])}
var staticRenderFns = []

export { render, staticRenderFns }